<template>
  <div
    v-if="!readonly"
    class="deletable-container d-flex mb-3"
    @mouseover="showDelete = true"
    @mouseleave="showDelete = false"
  >
    <div
      :class="{ 'filter-active-shadow': showDelete && !hideDeletableWrapper }"
    ></div>
    <div class="mr-6">
      <slot></slot>
    </div>
    <div
      v-if="!hideDeletableWrapper && showDelete"
      class="delete-icon-container d-flex justify-center align-center"
    >
      <div>
        <v-icon
          class="cursor-pointer"
          size="10"
          color="blue-grey"
          @click="$emit('delete')"
        >
          mdi-close-circle
        </v-icon>
      </div>
    </div>
  </div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DeletableFilterWrapper',

  props: {
    readonly: Boolean,
    hideDeletableWrapper: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showDelete: false,
    }
  },
}
</script>

<style scoped lang="scss">
.deletable-container {
  position: relative;
}
.filter-active-shadow {
  background-color: $color-blue-grey-lighten3;
  width: 100%;
  height: 40px;
  position: absolute;
  left: -4px;
  top: -4px;
  border-radius: 8px;
}

.delete-icon-container {
  position: absolute;
  right: 8px;
  min-width: 12px !important;
  height: 32px !important;
}
</style>
